<template>
  <div class="dsf-sc-admin-head">
    <div class="_sc-ah_l">
      <img class="_sc-ah-logo" :src="logo" />
      <div class="_sc-ah-admin-text">
        <div>{{ logoTitle }}<span v-if="$route.path == '/pc/lanPlatformHome'" style="color: #f33a3d; font-weight: normal">(涉密)</span>
        </div>
        <div class="mi" v-if="smTitle">
          <img :src="miPng" class="mi-png" >{{ smTitle }}
        </div>
      </div>
    </div>
    <div class="_sc-ah_r">
      <div class="_sc-ah-search">
        <DsfIcon class="_sc-ah-s-icon" name="sousuo2"></DsfIcon>
        <input class="_sc-ah-s-input" placeholder="请输入" />
      </div>
      <el-dropdown @command="dropdownCommand" :disabled="pageSuffix == 'lite'">
        <label class="_sc-ah-s-item">
          <!-- <DsfIcon class="_sc-ah-s-item-icon" name="icon-user" /> -->
          <div
            class="user-icon"
            :style="{
              'background-image': `url(${defaultUserIcon})`,
            }"
          >
            <img
              v-show="showIcon"
              :src="updateIconUrl"
              alt=""
              @error="headLoadError"
              @load="headLoadSuccess"
            />
          </div>
          <div class="_sc-ah-s-item-text">
            <h2>{{ userType || userName }}</h2>
            <p>{{ groupText }}</p>
          </div>
        </label>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="changePassword">
            修改密码
          </el-dropdown-item>
          <el-dropdown-item
            v-if="isToEditor"
            :command="handleOpenUserInfoWindow"
          >
            个人信息
          </el-dropdown-item>
          <el-dropdown-item :command="handleOpenAccountInfoWindow">
            账号信息
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <!-- <label class="_sc-ah-s-item">
        <DsfIcon class="_sc-ah-s-item-icon" name="icon-user" />
        <div class="_sc-ah-s-item-text">{{ userType || userName }}</div>
      </label> -->
      <label
        v-show="operationManual(true)"
        class="_sc-ah-s-item"
        @click="operationManual(false)"
      >
        <DsfIcon class="_sc-ah-s-item-icon" name="icon-help" />
        <div class="_sc-ah-s-item-text">操作手册</div>
      </label>
      <label class="_sc-ah-s-item" @click="offOut">
        <DsfIcon class="_sc-ah-s-item-icon" name="icon-exit" />
        <div class="_sc-ah-s-item-text">退出</div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userType: {
      default: "",
    },
    pageSuffix: {
      type: String,
      default: "else",
    },
  },
  data() {
    return {
      logo: dsf.config.setting_platform_logo_image || require("../../../assets/styles/img/work/logo-tj1.png"),
      userName: dsf.cookies.get("a") || dsf.cookies.get("user_name"),
      operationManualList: [],
      // 是否显示头像
      showIcon: false,
      updateIconTime: new Date().valueOf(),
      groupText: dsf.cookies.get("b"),
      logoTitle: dsf.config.setting_platform_logo_title || '统计云工作台',
      smTitle: dsf.config.setting_platform_attach_logo_title,
      miPng: dsf.config.setting_platform_attach_logo_image || require("../../../assets/styles/img/mi.png"),
    };
  },
  computed: {
    isToEditor() {
      return dsf.config.setting_public_hidden_update_user_info != 1;
    },
    // 用户默认头像
    defaultUserIcon() {
      let url = dsf.config.setting_public_user_default_header;
      return this.$replace(url);
    },
    updateIconUrl() {
      return `/oua2/getCurrentUserPhoto?t=${this.updateIconTime}`;
    },
  },
  methods: {
    // 头像加载成功时
    headLoadSuccess() {
      this.showIcon = true;
    },
    // 头像加载失败时
    headLoadError() {
      this.showIcon = false;
    },
    offOut() {
      this.$emit("loginOut");
    },
    changePassword() {
      let isSuccess = false;
      dsf.layer.openDialog({
        title: "修改密码",
        width: "600px",
        height: "600px",
        params: {
          path: "pc/dsfa/platformhome/alterPassword",
          onSuccess: () => {
            isSuccess = true;
          },
        },
        closed: () => {
          if (isSuccess) {
            location.replace(dsf.config.setting_public_pc_login_page);
          }
        },
      });
    },
    // 打开用户详情窗口
    handleOpenUserInfoWindow() {
      // 获取信息编辑地址
      this.$http.get("/oua2/quickEdit").done((res) => {
        if (res.success) {
          this.$openDialog({
            title: "个人信息",
            showClose: true,
            top: "5vh",
            height: "820px",
            width: "1230px",
            params: {
              path: res.data,
            },
            onClosed: () => {
              this.updateIconTime = new Date().valueOf();
            },
          });
        } else {
          dsf.layer.message("获取地址失败", false);
        }
      });
    },
    // 打开账号详情窗口
    handleOpenAccountInfoWindow() {
      this.$openDialog({
        title: "账号信息",
        showClose: true,
        top: "5vh",
        height: "820px",
        width: "1230px",
        content: "DsfAccountInfo",
        onClosed: () => {},
      });
    },
    dropdownCommand(command) {
      if (dsf.type(command) == "function") {
        command.call(this);
      }
    },
    operationManual(isDisabled) {
      const operationManualList = this.operationManualList;
      return operationManualList.some(({ roleIds = [], url }) => {
        return roleIds.some((roleId) => {
          if (
            JSON.parse(dsf.cookies.get("roles") || "[]").indexOf(
              "8a881c5770ea459eada25d8058363236"
            ) >= 0 ||
            JSON.parse(dsf.cookies.get("roles") || "[]").indexOf(roleId) >= 0
          ) {
            if (!isDisabled) {
              if (url) {
                window.open(url);
              } else {
                dsf.layer.message("没有配置操作手册地址", false);
              }
            }
            return true;
          }
          return false;
        });
      });
    },
    isDisabled({ urls, disabled }) {
      if (disabled) {
        return true;
      }
      if (
        JSON.parse(dsf.cookies.get("roles") || "[]").indexOf(
          "8a881c5770ea459eada25d8058363236"
        ) >= 0
      ) {
        return false;
      }
      if (urls && urls.length) {
        let state = urls.some(({ url, openType, roleId }) => {
          if (
            JSON.parse(dsf.cookies.get("roles") || "[]").indexOf(roleId) >= 0
          ) {
            return true;
          }
        });
        if (!state) {
          return true;
        }
      }
    },
    getGroupList() {
      dsf.http.get("/oua2/groupList").done((res) => {
        if (res.success) {
          if (res.data.currentGroupName) {
            this.groupText = res.data.currentGroupName.replace(
              /(.*)?\-.*/,
              "$1"
            );
          }
        }
      });
    },
    initRobotBtn() {
      this.robotBtnDom = $(
        `<div class="statistics-cloud-robot-btn" title="智能问答"></div>`
      );
      this.robotBtnDom.draggable({
        containment: "window",
      });
      this.robotBtnDom[0].onclick = () => {
        dsf.layer.openDialog({
          content: "DsfDialogIframe",
          title: "智能问答",
          params: {
            rmiframeUrl: "/platformasq/page.html#/pc/wiki/searchchat",
          },
          width: "1200px",
          height: "700px",
          top: "28px",
        });
      };
      this.robotBtnDom.appendTo($(document.body));
    },
  },
  created() {
    dsf.config.setting_public_statis_cloud_open_wiki_robot_btn &&
      this.initRobotBtn();
    this.$http.get("/static/data/dsf.head.json").then(({ data }) => {
      this.operationManualList = data.operationManualList || [];
    });
    document.title = this.logoTitle;
  },
  destroyed() {
    if (this.robotBtnDom) {
      this.robotBtnDom.draggable("destroy");
      this.robotBtnDom.remove();
    }
  },
};
</script>

<style lang="scss">
._sc-ah-logo{
  height: 90px;
  width: auto;
}
.statistics-cloud-robot-btn {
  display: inline-block;
  position: fixed;
  font-size: 0;
  width: 60px;
  height: 60px;
  top: calc(100vh - 120px);
  left: calc(100vw - 140px);
  z-index: 200;
  background: url("~_statistics-cloud/public/img/intelligent-robot.png") center no-repeat;
  background-size: cover;
  &:hover {
    cursor: pointer;
    border-radius: 60px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  }
}
</style>
